import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux'
import { Route, useLocation } from 'react-router-dom';
import auth from './services/auth/AuthProvider';
import LoadingPage from './components/Loading/loadingPage';
import AuthActions from './reducers/authRedux'

const PrivateRoute = props => {

    const location = useLocation()

    const {
        loginComplete,
        finalizeLogout,
        requestLogin,
        children,
        loaded,
        ...rest
    } = props

    useEffect(() => {
        if (!auth.isAuthenticated()) {
            // request new login
            requestLogin(location.pathname + location.search)
        }
    }, [])

    return (
        <Route {...rest}>
            {auth.isAuthenticated() && loginComplete 
                ? <Fragment>{children}</Fragment>
                : <LoadingPage loaded={loaded}/>
            }
        </Route>
    )
}

const mapStateToProps = (state) => ({
    loginComplete: state.auth.loginComplete
})

const mapDispatchToProps = (dispatch) => ({
    finalizeLogout: () => dispatch(AuthActions.finalizeLogout()),
    requestLogin: (redirect_url) => dispatch(AuthActions.requestLogin(redirect_url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);